import { render } from "./UserSettingsModal.vue?vue&type=template&id=215012b2&ts=true"
import script from "./UserSettingsModal.vue?vue&type=script&lang=ts"
export * from "./UserSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__